import { forEachObjIndexed, includes } from '@neo/ramda-extra'

export const mapToCreditAssessorCheckViewModel = (model) => {
  const mappedModel = {}

  const dynamicSteps = [
    'clientDetails',
    'clientIdentification',
    'creditReport',
    'incomeAndAssets',
    'expensesAndLiabilities',
  ]

  forEachObjIndexed((checkStatus, stepName) => {
    const isDynamicStep = includes(stepName, dynamicSteps)

    if (isDynamicStep) {
      const applicantsChecks = {}

      checkStatus.forEach(({ applicantId, isVerified }) => {
        applicantsChecks[applicantId] = {
          isVerified,
        }
      })

      mappedModel[stepName] = applicantsChecks
    }

    if (!isDynamicStep) mappedModel[stepName] = checkStatus
  }, model)

  return mappedModel
}
